import { isMedgateConnect } from "@/modules/patients/agenda/teleconsultation/booking/constants/medgate-connect"
import { MedgateConnectChannel, Service } from "@/types/__generated__/union-types"

type AppointmentForPartnerCheck = {
  service?: Service | null
  medgateConnectChannel?: MedgateConnectChannel | null
}

const shouldSendToPartner = (appointment: AppointmentForPartnerCheck | null | undefined): boolean =>
  !!appointment?.service && isMedgateConnect(appointment.service) && appointment.medgateConnectChannel === "PARTNER"

export { shouldSendToPartner }
